import { SceneSchedule } from './scene-schedule.model';

export class SceneSchedules
{
    constructor(json: any = null)
    {
        if (json)
        {
            if (json.ScheduleA)
            {
                this.ScheduleA = new SceneSchedule(json.ScheduleA);
            }

            if (json.ScheduleB)
            {
                this.ScheduleB = new SceneSchedule(json.ScheduleB);
            }

            return;
        }
        this.ScheduleA = new SceneSchedule();
        this.ScheduleB = new SceneSchedule();
    }

    public ScheduleA: SceneSchedule;
    public ScheduleB: SceneSchedule;
}
